import { sellerConstants } from '../../../_constants/seller.constants';
import { sellerAdminService } from '../../../_services';

export const MakePrimaryAdminAction = {
    makePrimaryAdmin
};

function makePrimaryAdmin(data) {
    return dispatch => {
        dispatch(request());
        sellerAdminService.makePrimaryAdmin(data)
            .then(
                response => {
                    dispatch(success(response));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: sellerConstants.REQUEST_SELLER_PRIMARY_ADMIN} }
    function success(data) { return { type: sellerConstants.SELLER_PRIMARY_ADMIN_SUCCESS, data } }
    function failure(error) { return { type: sellerConstants.SELLER_PRIMARY_ADMIN_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/sellers/sellerAdmin/makePrimaryAdmin.actions.js